module.exports = __webpack_public_path__ + "static/media/triangle.a4acaf05.svg";